// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 600px;
  margin: 40px auto;
  padding: var(--space-7) var(--space-6);
  min-height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: var(--color-surface);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-xl);
  box-sizing: border-box;
}

/* Tablet and mobile: container spans full width */
@media (max-width: 1024px) {
  .container {
    max-width: calc(100% - 32px);
    width: 100%;
    margin: 24px auto;
    padding: var(--space-6) var(--space-5);
  }
}

@media (max-width: 768px) {
  .container {
    max-width: 100%;
    margin: 0;
    min-height: 100vh;
    border: none;
    border-radius: 0;
    padding: var(--space-4);
  }
}

.stepHeader {
  text-align: left;
  margin-bottom: 32px;
}

.stepLabel {
  color: var(--color-dark-gray);
  margin-bottom: 4px;
}

.stepTitle {
  margin-bottom: 32px;
}

.form {
  margin-bottom: 32px;
}

.inputGroup {
  margin-bottom: 24px;
}

.inputLabel {
  font-weight: 600;
  margin-bottom: 4px;
}

.buttonGroup {
  margin-bottom: 16px;
}

.backButton {
  color: var(--accent);
}

.productList {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  justify-content: flex-start;
  margin-bottom: 40px;
  min-height: 120px;
}

.empty-products-state {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 120px;
  padding: 24px;
  border: 2px dashed var(--color-light-gray);
  border-radius: 8px;
  background-color: var(--color-white);
}

.buttonContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 32px;
}

.primaryButton {
  width: 260px;
} `, "",{"version":3,"sources":["webpack://./src/pages/Onboarding.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,4CAA4C;EAC5C,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE;IACE,4BAA4B;IAC5B,WAAW;IACX,iBAAiB;IACjB,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".container {\n  max-width: 600px;\n  margin: 40px auto;\n  padding: var(--space-7) var(--space-6);\n  min-height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border-subtle);\n  border-radius: var(--radius-xl);\n  box-sizing: border-box;\n}\n\n/* Tablet and mobile: container spans full width */\n@media (max-width: 1024px) {\n  .container {\n    max-width: calc(100% - 32px);\n    width: 100%;\n    margin: 24px auto;\n    padding: var(--space-6) var(--space-5);\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    max-width: 100%;\n    margin: 0;\n    min-height: 100vh;\n    border: none;\n    border-radius: 0;\n    padding: var(--space-4);\n  }\n}\n\n.stepHeader {\n  text-align: left;\n  margin-bottom: 32px;\n}\n\n.stepLabel {\n  color: var(--color-dark-gray);\n  margin-bottom: 4px;\n}\n\n.stepTitle {\n  margin-bottom: 32px;\n}\n\n.form {\n  margin-bottom: 32px;\n}\n\n.inputGroup {\n  margin-bottom: 24px;\n}\n\n.inputLabel {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.buttonGroup {\n  margin-bottom: 16px;\n}\n\n.backButton {\n  color: var(--accent);\n}\n\n.productList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 32px;\n  justify-content: flex-start;\n  margin-bottom: 40px;\n  min-height: 120px;\n}\n\n.empty-products-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 120px;\n  padding: 24px;\n  border: 2px dashed var(--color-light-gray);\n  border-radius: 8px;\n  background-color: var(--color-white);\n}\n\n.buttonContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  margin-top: 32px;\n}\n\n.primaryButton {\n  width: 260px;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
